// extracted by mini-css-extract-plugin
export default {"BasePage":"BasePage_BasePage__rzYzQ"};